module.exports = __webpack_public_path__ + "img/lookbook_15_right.aec578e3.png";